<div class="modal-head">
  <h1 mat-dialog-title class="mb-0">
    {{ "MUSIC_INFO.CREATE_PLAYLIST" | translate }}
  </h1>
  <a href="javascript:void(0)" mat-button (click)="close()">
    <span class="mdi mdi-close"></span>
  </a>
</div>
<hr class="mb-0" />
<div class="modal-body song-list-body" mat-dialog-content *ngIf="data !== 'create'">
  <ul *ngFor="let data of playListData">
    <li>
      <a href="javascript:void(0)" class="playlistname" (click)="createPlayList(data)">
        <span class="mdi mdi-playlist-music-outline"></span>
        {{ data.name }}
      </a>
    </li>
  </ul>
</div>

<div mat-dialog-actions>
  <div class="form-group w-100">
    <input type="text" (keyup.enter)="createPlayList('')" placeholder="Your New Playlist Name" class="form-control"
      [(ngModel)]="model.name" />
  </div>
  <a href="javascript:void(0)" class="btn-theme btn w-100" (click)="createPlayList('')">
    Save
  </a>
</div>